<template>
	<section class="Radio">
		<Form :form="form" :data="formData" @change="onSelect" />
		<Button :disabled="!(this.multiselect ? this.formData.chosen.length : this.formData.chosen)" @click="onConfirm">選択を確定する</Button>
	</section>
</template>

<script>
	export default {
		props: ['options', 'multiselect'],
		data() {
			return {
				formData: {
					chosen: this.multiselect ? [] : null
				}
			};
		},

		methods: {
			onSelect(key, value) {
				this.formData.chosen = value;
			},
			onConfirm() {
				this.$emit('select', this.formData.chosen);
			}
		},

		computed: {
			form() {
				return [
					{
						name: 'chosen',
						type: 'radio',
						multiselect: this.multiselect,
						options: [...new Set(this.options)].filter(e => e).map(v => ({
							label: v,
							value: v
						}))
					}
				];
			}
		}
	};
</script>

<style scoped lang="scss">
	.Radio {
		padding: 1rem 1.6rem;
		position: relative;

		/deep/ .Form {
			.input-area {
				display: flex;
				flex-direction: column;
			}
			margin-bottom: 1rem;
		}

		.Button {
			width: 100%;
		}
	}
</style>
